import React, { Fragment } from 'react';
import PerfectScrollBar from 'react-perfect-scrollbar';
import { GiAnticlockwiseRotation } from 'react-icons/gi';
import {
  formatDate,
  mapRightType,
  numberFormat,
  _formatDate2,
  StringToInt,
  StringToDouble,
} from '../../utils';
import { Button } from 'react-bootstrap';
import { take, takeRight, isEqual } from 'lodash';
import { connect } from 'react-redux';
import {
  makeGetToken,
  makeGetSummaryRightList,
  // makeGetRightList,
} from '../../lib/selector';
import { v4 as uuidv4 } from 'uuid';
import { rightEventRequest } from '../../containers/summary/actions';
import PaginationTable from '../PaginationTable';
import { translate } from 'react-i18next';
// import { rightListRequest } from '../../containers/cash/actions';
class TaiSan extends React.PureComponent {
  state = {
    contentShow: [],
    page: 1,
    continued: false,
    totalPage: 1,

    rightShow: [],
  };

  componentDidMount() {
    this._handleGetRightList();
    this.props.reload();
  }

  componentDidUpdate(preProps) {
    const { positions, account } = this.props;
    if (positions && !isEqual(positions, preProps.positions)) {
      this.setState({
        totalCount: positions ? positions.length : 0,
      });
      this.handleQueryPage(1);
    }

    if (account && !isEqual(account, preProps.account)) {
      this._handleGetRightList();
    }
  }

  _handleGetRightList = () => {
    const { account, token } = this.props;

    if (!token || !account) return;

    const uuid = uuidv4();
    const params = {
      group: 'CORE',
      user: token.user,
      session: token.session,
      cmd: 'getRightList',
      rqId: uuid,
      channel: 'WTS',
      data: {
        acntNo: account.acntNo,
        subAcntNo: account.subAcntNo,
      },
    };

    this.props.dispatch(rightEventRequest(params));
  };

  handleQueryPage = (page) => {
    const { positions } = this.props;
    if (!positions) return;
    const _pageSize = 15;
    const totalPage =
      positions && positions.length > 0
        ? Math.ceil(positions.length / _pageSize)
        : 1;

    const _takeContent = take(positions, _pageSize * page);
    const _contentShow = takeRight(
      _takeContent,
      _takeContent.length - _pageSize * (page - 1)
    );
    console.log(_contentShow);
    this.setState({
      contentShow: _contentShow,
      page,
      continued: page < totalPage,
      totalPage,
    });
  };

  _handleNextPage = (step) => {
    const { page } = this.state;
    this.handleQueryPage(page + step);
  };

  render() {
    const { cashBalance, positions, rightList, t } = this.props;
    const { contentShow, page, continued, totalPage, rightShow } = this.state;

    console.log('rightList', rightList);

    const columns = [
      {
        key: 'symbol',
        text: t('txt-symbol'),
        className: 'text-center',
        align: 'center',
      },
      {
        text: t('txt-type'),
        className: 'text-center',
        align: 'center',
        cell: (record) => {
          return mapRightType(record.rghtSubTp);
        },
      },
      {
        key: 'basdt',
        text: t('txt-label-expected-date'),
        className: 'text-center',
        align: 'center',
        cell: (record) => {
          return _formatDate2(record.basdt);
        },
      },
      {
        text: t('txt-label-registration-date'),
        className: 'text-center',
        align: 'center',
        cell: (record) => {
          if (record.rghtSubTp === '01') {
            if (record.dpstStockQty > 0) return _formatDate2(record.stockDate);

            if (record.dpstCashAmt > 0) return _formatDate2(record.cashDate);
          }

          return _formatDate2(record.stockDate);
        },
      },
      {
        key: 'balanceQuantity',
        text: t('txt-label-quantity-record-date'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          return numberFormat(record.balanceQuantity, 0, '0');
        },
      },
      {
        key: 'rightRate',
        text: t('txt-label-ratio'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          if (record.rghtSubTp === '01') {
            return (
              numberFormat(StringToDouble(record.rightRate), 0, '2') + '%'
            );
          }
          return record.rightRate;
        },
      },
      {
        text: t('txt-stock-waiting'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          return numberFormat(record.dpstStockQty, 0, '0');
        },
      },
      {
        text: t('txt-asset-collateral'),
        className: 'text-right',
        align: 'center',
        cell: (record) => {
          return numberFormat(record.dpstCashAmt, 0, '0');
        },
      },
    ];

    return (
      <Fragment>
        <div className="d-flex flex-row mt-3">
          <span
            className="mr-auto ml-2 text-white"
            style={{ fontSize: '18px' }}
          >
            {`${t('txt-detail')} ${t('txt-account')}`}
          </span>
          <a
            className="mr-3 btn-reload"
            onClick={() => {
              this._handleGetRightList();
              this.props.reload();
            }}
          >
            <GiAnticlockwiseRotation className="fz-14 text-white" />
          </a>
        </div>
        <PerfectScrollBar style={{ height: 'calc(100% - 155px)' }}>
          <label className="text-white mt-3 ml-2 fz-14">
            {t('txt-label-overview')}
          </label>
          <div className="d-flex m-2">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className="text-right">{t('txt-asset-total')}</th>
                  <th className="text-right">{t('txt-asset-nav')}</th>
                  <th className="text-right">{t('txt-asset-withdrawal')}</th>
                  <th className="text-right">{t('txt-label-total-loan')}</th>
                  <th className="text-right">{'RTT'}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-right">
                    {cashBalance && numberFormat(cashBalance.assets, 0, '0')}
                  </td>
                  <td className="text-right">
                    {cashBalance && numberFormat(cashBalance.nav, 0, '0')}
                  </td>
                  <td className="text-right">
                    {cashBalance &&
                      numberFormat(cashBalance.wdrawAvail, 0, '0')}
                  </td>
                  <td className="text-right">
                    {cashBalance && numberFormat(cashBalance.debt, 0, '0')}
                  </td>
                  <td className="text-right">
                    {cashBalance && cashBalance.marginRate}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <label className="text-white mt-3 ml-2 fz-14">
            {t('txt-label-position')}
          </label>
          <div className="d-flex flex-column m-2">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className="text-right">{t('txt-symbol')}</th>
                  <th className="text-right">{t('txt-total-vol')}</th>
                  <th className="text-right">{t('txt-label-avail')}</th>
                  <th className="text-right">
                    {t('txt-label-pending-delivery')}
                  </th>
                  <th className="text-right">
                    {t('txt-label-pending-trading')}
                  </th>
                  <th className="text-center">{`${t('txt-buy')} T2`}</th>
                  <th className="text-center">{`${t('txt-buy')} T1`}</th>
                  <th className="text-center">{`${t('txt-buy')} T0`}</th>
                  <th className="text-center">{t('txt-ave')}</th>
                  <th className="text-center">{t('txt-market-price')}</th>
                  <th className="text-center">{t('txt-change')}</th>
                  <th className="text-center">{t('txt-change-per')}</th>
                  <th className="text-center">{t('txt-label-buy-amt')}</th>
                  <th className="text-center">{t('txt-label-market-value')}</th>
                  <th className="text-right">{t('txt-gain-loss')}</th>
                  <th className="text-right">{`% ${t('txt-gain-loss')}`}</th>
                </tr>
              </thead>
              <tbody>
                {contentShow &&
                  !!contentShow.length &&
                  contentShow.map((item, index) => {
                    if (item.symbol === 'TOTAL')
                      return (
                        <tr key={index}>
                          <td
                            colSpan="12"
                            className="text-left font-weight-bold text-uppercase high-light"
                          >
                            {t('txt-total-num')}
                          </td>
                          <td className="text-right high-light">
                            {numberFormat(item.totBuyAmt, 0, '0')}
                          </td>
                          <td className="text-right high-light">
                            {numberFormat(item.totCurAmt, 0, '0')}
                          </td>
                          <td
                            className={
                              'text-right high-light ' +
                              (item.gainLoss > 0
                                ? 'i'
                                : item.gainLoss < 0
                                ? 'd'
                                : 'r')
                            }
                          >
                            {numberFormat(item.gainLoss, 0, '0')}
                          </td>
                          <td
                            className={
                              'text-right high-light ' +
                              (item.gainLoss > 0
                                ? 'i'
                                : item.gainLoss < 0
                                ? 'd'
                                : 'r')
                            }
                          >
                            {numberFormat(item.gainLossPc, 2, '-')}%
                          </td>
                        </tr>
                      );
                    return (
                      <tr key={index}>
                        <td
                          className={
                            'text-right font-weight-bold ' +
                            (item.gainLoss > 0
                              ? 'i'
                              : item.gainLoss < 0
                              ? 'd'
                              : 'r')
                          }
                        >
                          {item.symbol}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.balQty, 0, '0')}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.trdAvailQty, 0, '0')}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.sellTn, 0, '0')}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.waitTrdQty, 0, '0')}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.buyT2, 0, '0')}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.buyT1, 0, '0')}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.buyT0, 0, '0')}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.avgPrice, 3, '0')}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.lastPrice, 2, '0')}
                        </td>
                        <td
                          className={
                            'text-right ' +
                            (StringToInt(item.change) > 0
                              ? 'i'
                              : StringToInt(item.change) < 0
                              ? 'd'
                              : 'r')
                          }
                        >
                          {numberFormat(item.change / 1000, 2, '0')}
                        </td>
                        <td
                          className={
                            'text-right ' +
                            (StringToInt(item.change) > 0
                              ? 'i'
                              : StringToInt(item.change) < 0
                              ? 'd'
                              : 'r')
                          }
                        >
                          {item.changePC}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.totBuyAmt, 0, '0')}
                        </td>
                        <td className="text-right">
                          {numberFormat(item.totCurAmt, 0, '0')}
                        </td>
                        <td
                          className={
                            'text-right ' +
                            (item.gainLoss > 0
                              ? 'i'
                              : item.gainLoss < 0
                              ? 'd'
                              : 'r')
                          }
                        >
                          {numberFormat(item.gainLoss, 0, '0')}
                        </td>
                        <td
                          className={
                            'text-right ' +
                            (item.gainLoss > 0
                              ? 'i'
                              : item.gainLoss < 0
                              ? 'd'
                              : 'r')
                          }
                        >
                          {numberFormat(item.gainLossPc, 2, '-')}%
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {(!positions || !positions.length) && (
              <p className="text-center fz-14 mt-2 title-time">
                {t('txt-no-data-found')}
              </p>
            )}
            {positions && (
              <div className="d-flex flex-row-reverse align-items-center paging mt-2">
                <div className="d-flex align-items-center">
                  <Button
                    onClick={() => this._handleNextPage(-1)}
                    disabled={page === 1}
                    className="d-flex align-items-center justify-content-center"
                  >
                    {'<'}
                  </Button>
                  <Button
                    onClick={() => this._handleNextPage(1)}
                    disabled={!continued}
                    className="d-flex align-items-center justify-content-center"
                  >
                    {'>'}
                  </Button>
                </div>
                <span className="fz-14 text-white mr-2">{`Trang ${
                  page + '/' + totalPage
                }`}</span>
              </div>
            )}
          </div>
          <label className="text-white mt-3 ml-2 fz-14">
            {t('txt-label-right')}
          </label>
          <PaginationTable
            pageSize={15}
            columns={columns}
            source={rightList && rightList.list ? rightList.list : []}
          />
        </PerfectScrollBar>
      </Fragment>
    );
  }
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getSummaryRightList = makeGetSummaryRightList();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      rightList: getSummaryRightList(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(translate('translations')(TaiSan));
